import React, { useContext } from "react";
import { MiscContext } from "components/MiscProvider";

export default function useTheme() {
  const { theme, setTheme } = useContext(MiscContext);
  return { theme, setTheme };
}
